/**
 * Training settings tab — configure the registered company used as the headcount
 * denominator (Total A) in the computed training KPIs. Options are the distinct
 * register_company_name values from riu_users.
 */
import React, { useEffect, useState } from "react";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";
import {
  SettingLayout,
  SettingsCard,
  SettingsFormGroup,
  SettingsFormLabel,
  SettingsFormSelect,
} from "./SettingShell";

const BASE = `${config.POSTLOGIN_API_URL_COMPANY}trainingSettings`;

const saveBtnStyle = {
  padding: "9px 20px",
  borderRadius: 9,
  border: "none",
  background: "#3f88a5",
  color: "#fff",
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
};

const Training = () => {
  const [options, setOptions] = useState([]);
  const [denominatorCompany, setDenominatorCompany] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [opts, settings] = await Promise.all([
          apiCall(`${BASE}/company-options`, {}, {}, "GET", false, false),
          apiCall(BASE, {}, {}, "GET", false, false),
        ]);
        if (!active) return;
        setOptions(opts?.data || []);
        setDenominatorCompany(settings?.data?.denominatorCompany || "");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiCall(BASE, {}, { denominatorCompany }, "PUT", true, true, "Training settings saved");
    } finally {
      setSaving(false);
    }
  };

  return (
    <SettingLayout title="Training" subtitle="Configure training KPI computation">
      <SettingsCard style={{ padding: 20 }}>
        <SettingsFormGroup>
          <SettingsFormLabel>Denominator company</SettingsFormLabel>
          <SettingsFormSelect
            value={denominatorCompany}
            onChange={(e) => setDenominatorCompany(e.target.value)}
            disabled={loading}
          >
            <option value="">{loading ? "Loading…" : "Select a company…"}</option>
            {options.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </SettingsFormSelect>
          <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
            Registered company whose headcount is used as the denominator (Total A) in the
            computed training KPIs.
          </div>
        </SettingsFormGroup>

        <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={handleSave}
            disabled={saving || loading || !denominatorCompany}
            style={{ ...saveBtnStyle, opacity: saving || loading || !denominatorCompany ? 0.6 : 1 }}
          >
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </SettingsCard>
    </SettingLayout>
  );
};

export default Training;
